import * as z from "zod";

const ExpansionSegmentResult_ = z.object({
  segmentId: z.string(),
  segmentName: z.string(),
  sampleSize: z.number(),
  actualCount: z.number(),
});
export const ExpansionSegmentResult: z.ZodType<ExpansionSegmentResult> =
  ExpansionSegmentResult_;
export interface ExpansionSegmentResult extends z.infer<
  typeof ExpansionSegmentResult_
> {}

export const createExpansionSegments = {
  name: "createExpansionSegments" as const,
  input: z.object({
    teamId: z.string(),
    baseSegmentId: z.string(),
    sampleSizes: z.array(z.number().positive()),
    limitToSubscribers: z.boolean(),
    namingPrefix: z.string().optional(),
  }),
  output: z.object({
    baseSegmentId: z.string(),
    baseSegmentName: z.string(),
    createdSegments: z.array(ExpansionSegmentResult),
    totalAvailableCustomers: z.number(),
  }),
};
